import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import MarketingLayout from './_layout';

const faqs = [
  {
    q: 'What is Messego?',
    a: 'Messego is a unified workspace that combines messaging, social networking, commerce, career tools, and a financial wallet into one product for individuals and businesses.',
  },
  {
    q: 'Is Messego free to use?',
    a: 'Individuals can use the core product for free. Businesses pay based on the team size and modules they enable. All pricing is published transparently on our pricing page.',
  },
  {
    q: 'How is my data protected?',
    a: 'All data is encrypted in transit and at rest using AES-256. We support SSO, SCIM, and audit logs for enterprise customers, and we are SOC 2 Type II certified.',
  },
  {
    q: 'Can I use Messego with my existing tools?',
    a: 'Yes. We offer first-class APIs, webhooks, and integrations with the major identity, calendaring, accounting, and CRM platforms.',
  },
  {
    q: 'Where is Messego available?',
    a: 'Messego is available worldwide. Some financial features are restricted to specific jurisdictions where we hold the appropriate licenses.',
  },
  {
    q: 'How do I close my account?',
    a: 'You can close your account from Settings → Account → Close Account, or by contacting support. We will export your data on request before deletion.',
  },
];

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <MarketingLayout
      title="Frequently asked questions"
      subtitle="The questions we hear most often. Need something else? Our team is one click away on the Contact page."
    >
      <div className="space-y-3">
        {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i} className="bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-2xl overflow-hidden">
              <button
                onClick={() => setOpenIndex(isOpen ? null : i)}
                className="w-full text-left px-6 py-5 flex items-center justify-between gap-6"
              >
                <span className="font-bold text-neutral-900 dark:text-neutral-50">{faq.q}</span>
                <ChevronDown
                  size={18}
                  className={`flex-shrink-0 text-neutral-400 dark:text-neutral-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                />
              </button>
              {isOpen && (
                <div className="px-6 pb-5 text-sm text-neutral-500 dark:text-neutral-400 leading-relaxed">{faq.a}</div>
              )}
            </div>
          );
        })}
      </div>
    </MarketingLayout>
  );
}
